export enum PersonType {
  LEGAL = 'LEGAL',
  PRIVATE = 'PRIVATE',
}
